import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress, TablePagination, Grid, Dialog, DialogContentText, DialogActions, DialogTitle, DialogContent, Button, Box, ButtonGroup, Typography, Select, MenuItem, OutlinedInput, InputAdornment, Table, TableHead, TableRow, TableCell, TableBody, IconButton, FormControl, InputLabel } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { StyledDialog, StyledPaper } from "../StyledMui";
import useStore from "../Store";
import NewTemplateDialog from "./NewTemplateDialog";
import ApiRequest from "../ApiRequest";
import AlertDialog from "../ReusableComponents/AlertDialog";
import { useAlert } from "../AlertProvider";

function ManageTemplateModal() {
  const { BASIC_ALERT_DURATION, setTemplateEditMode, closeModal, templateModal, openNewTemplateDialog, getTemplates, templates } = useStore((state) => state.header);

  useEffect(() => {
    if (templateModal) {
      getTemplates();
      setCurrentPage(0);
    }
  }, [templateModal]);
  const [templateToDelete, setTemplateToDelete] = useState(null);
  const [alertDialog, setAlertDialog] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedType, setSelectedType] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loadingModal, setLoadingModal] = useState(false);
  const { showAlert } = useAlert();

  const filteredTemplates = templates.filter((template) => selectedType === "all" || template.templateType === selectedType).filter((template) => template.templateCode.includes(searchKeyword) || template.templateName.includes(searchKeyword));
  const totalPages = Math.ceil(filteredTemplates.length / itemsPerPage);
  const currentTemplates = filteredTemplates.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  const handleSearchKeywordChange = (event) => {
    setSearchKeyword(event.target.value);
    setCurrentPage(0);
  };

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
    setCurrentPage(0);
  };

  const handleInspectionRequest = async (index) => {
    setLoadingModal(true);
    const template = currentTemplates[index];
    console.log("Selected Template:", template);
    let data = {
      senderKey: template.senderKey,
      templateCode: template.templateCode,
    };
    let apiResponse;
    try {
      let endPoint = "/biztalkCenterApi/alimtalk/template/request";
      apiResponse = await ApiRequest.post(endPoint, data);
      console.log("여기 : " + JSON.stringify(apiResponse));

      if (apiResponse.code === "200") {
        let updateData = {
          tableName: "template",
          data: {
            inspectionStatus: "REQ",
            status: "R",
          },
          filter: {
            id: template.Id,
          },
        };

        let endPoint = "/db/updateData";
        const apiResponse = await ApiRequest.post(endPoint, updateData);
        console.log(apiResponse);
        getTemplates();
        showAlert("검수요청이 정상적으로 접수되었습니다.", "success", BASIC_ALERT_DURATION);
      } else {
        showAlert(apiResponse.message, "error", BASIC_ALERT_DURATION);
      }
    } catch (error) {
      console.log(error);
    }
    setLoadingModal(false);
  };

  const handleTemplateDelete = (index) => {
    setTemplateToDelete(currentTemplates[index]);
    setAlertDialog(true);
  };

  const agreeAlertDialog = async () => {
    console.log(templateToDelete);
    setLoadingModal(true);
    let apiResponse;
    try {
      if (templateToDelete.templateType === "alimtalk") {
        let data = {
          senderKey: templateToDelete.senderKey,
          templateCode: templateToDelete.templateCode,
        };
        let endPoint = "/biztalkCenterApi/alimtalk/template/delete";
        apiResponse = await ApiRequest.post(endPoint, data);
        console.log("여기 : " + JSON.stringify(apiResponse));
      }

      if (templateToDelete.templateType === "friendtalk" || apiResponse.code === "200" || (apiResponse.code === "508" && apiResponse.message === "요청한 데이터가 존재하지 않습니다.")) {
        let endPoint = "/db/deleteData";
        let deleteData = {
          tableName: "template",
          filter: {
            id: templateToDelete.Id,
          },
        };
        console.log(deleteData);
        const apiResponse = await ApiRequest.post(endPoint, deleteData);
        console.log(apiResponse);
        setAlertDialog(false);
        getTemplates();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingModal(false);
    }
  };

  const handleInspectionRequestCancel = async (index) => {
    setLoadingModal(true);
    const template = currentTemplates[index];
    console.log("Selected Template:", template);
    let data = {
      senderKey: template.senderKey,
      templateCode: template.templateCode,
    };
    let apiResponse;
    try {
      let endPoint = "/biztalkCenterApi/alimtalk/template/cancel_request";
      apiResponse = await ApiRequest.post(endPoint, data);
      console.log("여기 : " + JSON.stringify(apiResponse));

      if (apiResponse.code === "200" || (apiResponse.code === "509" && apiResponse.message === "이미 검수가 취소된 템플릿입니다.")) {
        let updateData = {
          tableName: "template",
          data: {
            inspectionStatus: "REG",
            status: "R",
          },
          filter: {
            id: template.Id,
          },
        };

        let endPoint = "/db/updateData";
        const apiResponse = await ApiRequest.post(endPoint, updateData);
        console.log(apiResponse);
        getTemplates();
        showAlert("검수요청이 정상적으로 취소되었습니다.", "success", BASIC_ALERT_DURATION);
      } else {
        showAlert(apiResponse.message, "error", BASIC_ALERT_DURATION);
      }
    } catch (error) {
      console.log(error);
    }
    setLoadingModal(false);
  };

  return (
    <>
      <StyledDialog open={templateModal} onClose={() => closeModal("templateModal")}>
        <DialogContent>
          {loadingModal ? (
            <Backdrop open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <></>
          )}
          <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="h6">템플릿 관리</Typography>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" justifyContent="flex-end">
                  <ButtonGroup variant="contained">
                    <Button onClick={() => openNewTemplateDialog()}>생성</Button>
                    {/* <Button disabled>수정</Button>
                    <Button disabled>삭제</Button> */}
                  </ButtonGroup>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel htmlFor="type">유형 선택</InputLabel>
                  <Select
                    label="유형 선택"
                    value={selectedType}
                    onChange={handleTypeChange}
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    displayEmpty>
                    <MenuItem value="all">전체</MenuItem>
                    <MenuItem value="alimtalk">알림톡</MenuItem>
                    <MenuItem value="friendtalk">친구톡</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={10}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="search">검색</InputLabel>
                    <OutlinedInput
                      id="search"
                      value={searchKeyword}
                      onChange={handleSearchKeywordChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton type="submit" edge="end" aria-label="search">
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                      label="검색"
                    />
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>채널</TableCell>
                      <TableCell>템플릿유형</TableCell>
                      <TableCell>템플릿코드</TableCell>
                      <TableCell>템플릿명</TableCell>
                      <TableCell>메세지유형</TableCell>
                      <TableCell>강조유형</TableCell>
                      <TableCell>검수상태</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentTemplates.length > 0 ? (
                      currentTemplates.map((template, index) => (
                        <TableRow key={index}>
                          <TableCell>{template.channelName}</TableCell>
                          <TableCell>{template.templateType}</TableCell>
                          <TableCell>{template.templateCode}</TableCell>
                          <TableCell>{template.templateName}</TableCell>
                          <TableCell>{template.templateMessageType}</TableCell>
                          <TableCell>{template.templateEmphasizeType}</TableCell>
                          <TableCell>{template.inspectionStatus}</TableCell>
                          <TableCell>
                            <ButtonGroup>
                              {template.inspectionStatus === "REG" && template.status === "R" && (
                                <Button variant="contained" onClick={() => handleInspectionRequest(index)}>
                                  검수요청
                                </Button>
                              )}
                              {template.inspectionStatus === "REQ" && (
                                <Button variant="contained" onClick={() => handleInspectionRequestCancel(index)}>
                                  검수취소
                                </Button>
                              )}
                              {template.templateType === "friendtalk" || (template.templateType === "alimtalk" && (template.inspectionStatus === "REG" || template.inspectionStatus === "REJ")) ? (
                                <Button variant="contained" onClick={() => setTemplateEditMode(false, template, true, false)}>
                                  수정
                                </Button>
                              ) : (
                                <Button variant="contained" onClick={() => setTemplateEditMode(true, template, false, false)}>
                                  상세보기
                                </Button>
                              )}
                              <Button variant="contained" onClick={() => setTemplateEditMode(false, template, false, true)}>
                                복제
                              </Button>
                              {template.templateType === "friendtalk" || (template.templateType === "alimtalk" && (template.inspectionStatus === "REG" || template.inspectionStatus === "REJ")) ? (
                                <Button variant="contained" onClick={() => handleTemplateDelete(index)} color="error">
                                  삭제
                                </Button>
                              ) : (
                                <></>
                              )}
                            </ButtonGroup>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7}>No Templates available.</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <TablePagination style={{ overflowY: "hidden" }} component="div" rowsPerPageOptions={[]} count={filteredTemplates.length} page={currentPage} onPageChange={(event, newPage) => setCurrentPage(newPage)} rowsPerPage={itemsPerPage} onRowsPerPageChange={(event) => setItemsPerPage(parseInt(event.target.value))} />
        <DialogActions>
          <IconButton
            autoFocus
            onClick={() => closeModal("templateModal")}
            color="primary"
            style={{
              position: "absolute",
              left: "98%",
              top: "-40px",
              transform: "scale(1.5)",
              // backgroundColor: "lightgray",
              color: "lightgrey",
            }}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </StyledDialog>
      <AlertDialog open={alertDialog} title="삭제하시겠습니까?" description="삭제된 템플릿은 복구할 수 없습니다." onClose={() => setAlertDialog(false)} onConfirm={agreeAlertDialog} onCancel={() => setAlertDialog(false)} />
      <NewTemplateDialog />
    </>
  );
}

export default ManageTemplateModal;
